import React, { useEffect, useState } from 'react'
import ShortInfoCard from '../ShortInfoCard'
import { menu, shortFunction, sip } from '../../translate'
import { useNavigate } from 'react-router-dom'
import Api from '../../Api'

export default function BlockedComponent() {
    const navigate = useNavigate()
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [blockedNumbersCount, setBlockedNumbersCount] = useState(0)
    const [loadingNumbers, setLoadingNumbers] = useState(false)

    useEffect(() => {
        fetchBlockedNumbers()
    }, [])

   

    const fetchBlockedNumbers = async () => {
        setLoadingNumbers(true)
        try {
            const { data } = await Api.getBlocked(10, 1, '')
            const count = data?.count || 0
            setBlockedNumbersCount(count)
        } catch (e) {
            console.error('Error fetching blocked numbers:', e)
            setBlockedNumbersCount(0)
        } finally {
            setLoadingNumbers(false)
        }
    }

    return (
        <>
            <h3 style={{ margin: '20px 20px' }}>
                {menu.block[langIndex] || 'Blocked'}
            </h3>
            <div className="short-cards">
             
                
                <ShortInfoCard
                    label={`${menu.block[langIndex]} (${blockedNumbersCount})`}
                    description={langIndex === 1 ? `${blockedNumbersCount} blocked phone number${blockedNumbersCount !== 1 ? 's' : ''}` :
                                langIndex === 2 ? `${blockedNumbersCount} заблокированных номеров` :
                                `${blockedNumbersCount} արգելափակված հեռախոսահամար${blockedNumbersCount !== 1 ? 'ներ' : ''}`
                    }
                    onEdit={() => navigate('/blocked_numbers')}
                    editTitle={sip.action[langIndex]}
                >
                    <span
                        className="short-card__actions-item"
                        style={{
                            padding: '2px 12px',
                            color: 'white',
                            background: blockedNumbersCount > 0 ? '#7ebc0a' : '#ce405f'
                        }}
                    >
                        {blockedNumbersCount > 0 
                            ? shortFunction.status[langIndex] 
                            : shortFunction.in_status[langIndex]
                        }
                    </span>
                </ShortInfoCard>
            </div>
        </>
    )
}
